function comma(value, digit = 3) {
  return value.toString().replace(new RegExp('(\\d)(?=(?:\\d{'+digit+'})+(?!\\d))', 'g'), '$1,')
}

export {comma}
